import InvoicePreview from "./preview";
import Stepper from "./Stepper";
import InvoiceShow from "./InvoiceShow";


export default [
    {
        name: "invoice.stepper",
        path: "/app",
        component: Stepper,
        meta: { requiresAuth: false }
    },
    {
      name: "invoice.preview",
      path: "/preview",
      component: InvoicePreview,
      meta: { requiresAuth: false }
    }
    ,
    {
      name: "invoice.show",
      path: "/show/:id",
      component: InvoiceShow,
      meta: { requiresAuth: false }
    }
  ];